import {
  Button,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from '@hiiretail/react-foundation-ui';
import ImageIcon from '@mui/icons-material/Image';
import { ItemSearchReturnResponse } from 'app/services/itemsSearchService/itemsSearchTypes';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface ItemSearchResultItemProps {
  item: ItemSearchReturnResponse;
  onAddItem: () => void;
}

const styles = {
  addButton: {
    p: 1.5,
    flexShrink: 0,
  },
  name: {
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1,
   },
};

export const ItemsSearchResultItem: FC<ItemSearchResultItemProps> = ({ item, onAddItem }) => {
  const intl = useIntl();

  const handleAddItem = () => {
    onAddItem();
  };

  return (
    <ListItem
      disablePadding
      data-testid="item-option"
    >
      <ListItemButton disableRipple>
        <ListItemAvatar>
          {/* TODO: Use product image if exists */}
          <ImageIcon fontSize="large" />
        </ListItemAvatar>
        <ListItemText
          sx={styles.name}
          primary={item.name}
          primaryTypographyProps={{
            noWrap: true, // Ensure that the primary text does not wrap
          }}
        />
        <Button sx={styles.addButton} onClick={handleAddItem}>
          {intl.formatMessage({ id: 'items.search.autcomplete.item.add' })}
        </Button>
      </ListItemButton>
    </ListItem>
  );
};
